'use client'

import { usePathname } from 'next/navigation'
import { HomeLink } from '@/components/home-link'

interface NavigationLinksProps {
  hasMecUnity: boolean | null | undefined
  hasPostgraduateUnity: boolean | null | undefined
  plataformUnity: string | null | undefined
  isLogged: boolean
  unityId?: string
}

const linkClassName =
  'rounded-md p-2 font-medium text-gray-500 text-sm transition-colors duration-200 hover:bg-gray-500/10 data-[path=true]:text-primary-950'

export function NavigationLinks({
  hasMecUnity,
  hasPostgraduateUnity,
  plataformUnity,
  isLogged,
  unityId,
}: NavigationLinksProps) {
  const pathname = usePathname()

  // Filter based on unity ID requirements
  const hideCertificates = unityId === 'UE9E55FE9'
  const hideMec = unityId === 'UE9E55FE9'
  const hidePostgraduate = unityId === 'U08E5DDFF'

  return (
    <div className="hidden space-x-2 lg:flex">
      {isLogged ? (
        <HomeLink className={linkClassName} href="/cursos">
          Todos os cursos
        </HomeLink>
      ) : (
        <HomeLink className={linkClassName} href="/cursos">
          Cursos
        </HomeLink>
      )}

      {!(
        plataformUnity === 'Eduhot-staging' ||
        plataformUnity === 'Eduhot' ||
        isLogged ||
        hideCertificates
      ) && (
        <HomeLink
          className={linkClassName}
          data-path={pathname === '/certificado/sobre'}
          href="/certificado/sobre"
        >
          Certificados
        </HomeLink>
      )}

      {hasPostgraduateUnity && !hidePostgraduate && (
        <HomeLink
          className={linkClassName}
          data-path={pathname === '/cursos/pos-graduacoes'}
          href="/cursos/pos-graduacoes"
        >
          Pós-graduação
        </HomeLink>
      )}

      {hasMecUnity && !hideMec && (
        <HomeLink
          className={linkClassName}
          data-path={pathname === '/parceria-mec'}
          href="/parceria-mec"
        >
          e-MEC
        </HomeLink>
      )}
    </div>
  )
}
